import {axios} from '../../../lib'

export const getDocumentStats = () => {
    return axios.get('/stats/documents')
}
